module.exports = __webpack_public_path__ + "img/page.04e1cd06.png";